var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.33317V2.83317H12.5H4.16667H3.66667V3.33317V16.6665V17.1665H4.16667H15.8333H16.3333V16.6665V6.6665V6.1665H15.8333H13V3.33317ZM17 17.494L17 17.4975C17.0003 17.5413 16.992 17.5847 16.9755 17.6253C16.9591 17.6658 16.9348 17.7027 16.904 17.7339C16.8733 17.7651 16.8367 17.7899 16.7964 17.8069C16.7565 17.8238 16.7137 17.8327 16.6705 17.8332H3.3297C3.24262 17.8322 3.15935 17.7972 3.09772 17.7357C3.03615 17.6742 3.0011 17.591 3 17.5041V2.49317C3 2.31591 3.14537 2.1665 3.3325 2.1665H13.1262L17 6.04028L17 17.494ZM10.8333 9.49984H10.3333V9.99984V12.8332H9.66667V9.99984V9.49984H9.16667H7.87377L10 7.37361L12.1262 9.49984H10.8333Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportDoc);
export default __webpack_public_path__ + "static/media/export-doc.38b50836d828062bdda8371ab53c5499.svg";
export { ForwardRef as ReactComponent };